import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialogConfig as MatDialogConfig,
    MatLegacyDialogModule,
} from '@angular/material/legacy-dialog';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { firstValueFrom, Subject } from 'rxjs';
import { arlTableDataArlForm } from '../arl-calculation/arl-form-data.service';
import {
    AccountsReceivableLedgerEntity,
    AccountsReceivableLedgerTypeEnum,
} from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { getQuantityTypeDictionary } from '../../../dave-data-module/State/selectors/accounting.selector';
import { Store } from '@ngrx/store';
import { State } from '../../../dave-data-module/State';
import {
    getCustomerDictionary,
    getNotDeletedSuppliers,
} from '../../../dave-data-module/State/selectors/customers.selectors';
import { Dictionary } from '@ngrx/entity';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import { QuantityTypeEntity } from '../../../dave-data-module/entities/quantity-type.entity';

export interface arlTableData<T = AccountsReceivableLedgerEntity> {
    Sum: number;
    QuanityType: string;
    Name: string;
    Supplier: string;
}

interface requiredValues<T = AccountsReceivableLedgerEntity>{
    Type?: AccountsReceivableLedgerTypeEnum;
    QuantityTypeId?: number;
    Information?: string;
    Quantity?: number;
    SupplierId?: number;
    JobSpecificationId?: number;
    MaterialId?: number;
    ResourceId?: number;
}

export interface RequirementTableDialogComponentDialogData {
    arls: arlTableDataArlForm[];
    refreshArls: () => Promise<arlTableDataArlForm[]>;
}
@Component({
  selector: 'app-requirement-table-dialog',
  standalone: true,
    imports: [CommonModule, CdkDrag, CdkDragHandle, FontAwesomeModule, MatLegacyDialogModule, AppButtonModule],
  templateUrl: './requirement-table-dialog.component.html',
  styleUrls: ['./requirement-table-dialog.component.scss']
})
export class RequirementTableDialogComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        hasBackdrop: false,
        maxHeight: '50vh',
        maxWidth: '50vw'
    };

    tableData: arlTableData[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public DialogData: RequirementTableDialogComponentDialogData,
        protected cls: CustomLabelService,
        private store: Store<State>,
               ) {
        this.calculateTableData();
    }


    async refreshArls() {
        this.DialogData.arls = await this.DialogData.refreshArls();
        this.calculateTableData();
    }

    calculateArls(arl: requiredValues, groupedMap: Map<string, arlTableData>, qtDict: Dictionary<QuantityTypeEntity>, supplierDict: Dictionary<CustomerEntity>) {
        let key = ""
        switch (arl.Type) {
            case AccountsReceivableLedgerTypeEnum.EmployeeArl:
                key = `${arl.Type}_${arl.QuantityTypeId}_E${arl.JobSpecificationId}`;
                break;
            case AccountsReceivableLedgerTypeEnum.MaterialArl:
                key = `${arl.Type}_${arl.QuantityTypeId}_M${arl.MaterialId}_${arl?.SupplierId}`;
                break
            case AccountsReceivableLedgerTypeEnum.ResourceArl:
                key = `${arl.Type}_${arl.QuantityTypeId}_R${arl.ResourceId}`;
                break;
            default:
                key = `${arl?.Type}_${arl.QuantityTypeId}_${arl.Information}`;
                break;
        }

        if (groupedMap.has(key)) {
            const existing = groupedMap.get(key)!;
            existing.Sum += arl.Quantity || 0;
        } else {
            groupedMap.set(key, {
                Sum: arl.Quantity || 0,
                QuanityType: arl?.QuantityTypeId ?  qtDict[arl.QuantityTypeId].Name : '',
                Name: arl.Information || '',
                Supplier: arl?.SupplierId ?  supplierDict[arl.SupplierId].DisplayName : '',
            });
        }

    }


    async calculateTableData() {
        var qtDict = await firstValueFrom(this.store.select(getQuantityTypeDictionary))
        var supplierDict = await firstValueFrom(this.store.select(getCustomerDictionary))

        const groupedMap = new Map<string, arlTableData>();

        this.DialogData.arls.forEach(arl => {

            if(arl.controls.childArlsCalculation?.value != null && arl.controls.childArlsCalculation?.length > 0){
                arl.controls.childArlsCalculation.controls.forEach(childArl => {
                    this.calculateArls(childArl.value, groupedMap, qtDict, supplierDict)
                })
            }
             this.calculateArls(arl.value, groupedMap, qtDict, supplierDict)

        });

        this.tableData = Array.from(groupedMap.values());
    }
}
